angular
    .module('MW.Framework.InfluencerContactService', [
        'Configuration',
        'MW.Configuration',
        'MW.ContactManager.ContactManagerPropertyTypeService',
        'MW.ContactManager.ContactManagerContactModel',
        'MW.ContactManager.ContactManagerSourceService',
        'MW.CustomValidation.ContactManagerUsernameService',
        'MW.Framework.DateRangeHelper',
        'MW.Framework.CoreUserService',
        'MW.Framework.ICMUserService',
        'MW.ContactManager.ContactDomainModelConverter'
    ])
    .service('InfluencerContactService', [
        '$http',
        'CONTACT_MANAGER_CONTACT_URL',
        'ICM_CSS_URL',
        'ICM_CONTACT_SERVICE_URL',
        'ICM_CONTACTS_URL',
        'ICM_DOCUMENT_SERVICE_URL',
        'CONTACT_MANAGER_EXPORT_URL',
        'CONTACT_MANAGER_DOCUMENTS_URL',
        'CONTACT_MANAGER_NOTES_URL',
        'INFLUENCERS_URL',
        'ICM_SOURCE_SERVICE_URL',
        'ICM_CONTACT_SOURCE_SERVICE_API_KEY',
        '$q',
        'activeOnUrls',
        'activeOnTypes',
        'Contact',
        'ContactManagerSourceService',
        'ContactManagerUsernameService',
        'DOCUMENT_SEARCH_SERVICE_URL',
        'DateRangeHelper',
        'CoreUserService',
        'ICMUserService',
        'ICM_EMAIL_API_URL',
        'ContactDomainModelConverter',
        function($http,
                 CONTACT_MANAGER_CONTACT_URL,
                 ICM_CSS_URL,
                 ICM_CONTACT_SERVICE_URL,
                 ICM_CONTACTS_URL,
                 ICM_DOCUMENT_SERVICE_URL,
                 CONTACT_MANAGER_EXPORT_URL,
                 CONTACT_MANAGER_DOCUMENTS_URL,
                 CONTACT_MANAGER_NOTES_URL,
                 INFLUENCERS_URL,
                 ICM_SOURCE_SERVICE_URL,
                 ICM_CONTACT_SOURCE_SERVICE_API_KEY,
                 $q,
                 activeOnUrls,
                 activeOnTypes,
                 Contact,
                 ContactManagerSourceService,
                 ContactManagerUsernameService,
                 DOCUMENT_SEARCH_SERVICE_URL,
                 DateRangeHelper,
                 CoreUserService,
                 ICMUserService,
                 ICM_EMAIL_API_URL,
                 ContactDomainModelConverter) {
            'use strict';
            function _formatActiveOnUrls(channel, appendToUrl) {
                var channelType = channel.type.toUpperCase();

                if (activeOnUrls[channelType]) {
                    channel.url = activeOnUrls[channelType] + appendToUrl;
                }
            }

            function _formatUserName(channel) {
                if(channel.type === activeOnTypes.TWITTER) {
                    channel.userName = ContactManagerUsernameService.getTwitterUsername(channel.userName);
                    if(channel.userName[0] === '@') {
                        channel.userName = channel.userName.substr(1);
                    }
                } else if(channel.type === activeOnTypes.FACEBOOK) {
                    channel.userName = ContactManagerUsernameService.getFacebookUsername(channel.userName);
                }
            }

            function _formatActiveOn(contact) {
                var userNameChannels = [activeOnTypes.FACEBOOK.toLowerCase(), activeOnTypes.TWITTER.toLowerCase()],
                    urlChannels = [activeOnTypes.BLOG.toLowerCase(),activeOnTypes.LINKED_IN.toLowerCase()],
                    channels = contact.channels,
                    i = channels.length,
                    channel,
                    channelType;

                function _removeChannel(contact) {
                    contact.channels.splice(i, 1);
                }

                function _isPropertyEmpty(channel, property) {
                    return (channel[property] === undefined || channel[property] === '');
                }

                while (i--) {
                    channel = channels[i];

                    // disregard channel if it has no type
                    if(channel.type === undefined) {
                        _removeChannel(contact);
                    } else {
                        channelType = channel.type.toLowerCase();

                        // handle channels that are built based on User Names
                        if(userNameChannels.indexOf(channelType) > -1) {
                            if(_isPropertyEmpty(channel, 'userName')) {
                                _removeChannel(contact);
                            } else {
                                _formatUserName(channel);
                                _formatActiveOnUrls(channel, channel.userName);
                            }
                        }
                        // handle channels that are built based on URLs
                        else if(urlChannels.indexOf(channelType) > -1) {
                            if(_isPropertyEmpty(channel, 'url')) {
                                _removeChannel(contact);
                            } else {
                                _formatActiveOnUrls(channel, channel.url);
                            }
                        }
                    }
                }
            }

            var InfluencerContactService = {};
            //containing the total no. of contact present in contact list.
            InfluencerContactService.contactItemCount = 0;

            function _formatContactInfo(contact) {
                var contactInfo = contact.contactInfo,
                    checkContactInfoEmpty, i;

                checkContactInfoEmpty = function checkEmailEmpty(contactObj, infoType) {
                    switch (infoType) {
                        case 'email':
                            return !(contactObj.address);
                        case 'phone':
                            return !(contactObj.number);
                        case 'address':
                            return !(contactObj.zip ||
                                    contactObj.street ||
                                    contactObj.city ||
                                    contactObj.street2 ||
                                    contactObj.stateOrProvince ||
                                    contactObj.countryCode ||
                                    contactObj.countryName);
                    }
                };

                for(i = 0; i < contactInfo.email.length; i++) {
                    if (checkContactInfoEmpty(contactInfo.email[i], 'email')) {
                        contactInfo.email.splice(i, 1);
                        i--;
                    }
                }

                for(i = 0; i < contactInfo.phone.length; i++) {
                    if (checkContactInfoEmpty(contactInfo.phone[i], 'phone')) {
                        contactInfo.phone.splice(i, 1);
                        i--;
                    }
                }

                for(i = 0; i < contactInfo.address.length; i++) {
                    if (checkContactInfoEmpty(contactInfo.address[i], 'address')) {
                        contactInfo.address.splice(i, 1);
                        i--;
                    }
                }
            }

            InfluencerContactService.saveContact = function saveContact(contact) {
                var successMessage,
                    httpRequest,
                    deferred = $q.defer(),
                    self = this;
                ICMUserService.getIdentity().then((identity) => {
                    let formattedContact = JSON.parse(JSON.stringify(contact));
                    if(formattedContact.channels) {
                        // determine ActiveOn Account URLs
                        _formatActiveOn(formattedContact);
                    }

                    if(formattedContact.contactInfo) {
                        _formatContactInfo(formattedContact);
                    }
                    // determine if we are Creating or Updating
                    if(formattedContact.id) {
                        successMessage = 'Success. Your contact has been updated.';
                        httpRequest = $http.put(CONTACT_MANAGER_CONTACT_URL + '/' + formattedContact.id, ContactDomainModelConverter.convertToDomainModel(formattedContact, identity.company._id));
                    } else {
                        successMessage = 'Success. Your new contact has been created.';
                        httpRequest = $http.post(CONTACT_MANAGER_CONTACT_URL, ContactDomainModelConverter.convertToDomainModel(formattedContact, identity.company._id));
                        // httpRequest = $q.when('test')
                    }

                    httpRequest.then(function(response) {
                        var contact = response.data;
                        var contactViewModel = new Contact(contact, []);

                        self.setCurrentContact(contactViewModel);
                        deferred.resolve({contact: contactViewModel, message: successMessage});
                        deferred.resolve();
                    }).catch(function(response) {
                        deferred.reject(response.data);
                    });
                }).catch(function(err) {
                    deferred.reject(err);
                });
                return deferred.promise;
            };

            InfluencerContactService.importCsv = function importCsv(fileContents, selectedMediaListArray) {
                var deferred = $q.defer(),
                    formData = new FormData(),
                    payload = {'mediaLists': selectedMediaListArray};

                formData.append('model', angular.toJson(payload));
                formData.append('file1' , fileContents);
                $http.post(
                    CONTACT_MANAGER_CONTACT_URL + '/import',
                    formData,
                    {headers: {'Content-Type': undefined}
                }).then(function(response) {
                    deferred.resolve({payload: response.data, message: 'Success. Your contacts have been created.'});
                }).catch(function(response) {
                    deferred.reject(response.data);
                });

                return deferred.promise;
            };

            InfluencerContactService.exportSelected = function exportSelected(csvFileName, selectedContactData, pageSize) {
                var payload = {
                    selectedContactData: selectedContactData,
                    fileName: csvFileName,
                    pageSize: pageSize
                };

                return $q(function(resolve, reject) {
                    $http.post(CONTACT_MANAGER_EXPORT_URL + '/contacts/csv', payload).then(function(response) {
                        InfluencerContactService.downloadCsv(response.data);

                        resolve({success: true});
                    }).catch(function(response) {
                        reject(response.data);
                    });
                }).catch(function() {});
            };

            InfluencerContactService.exportByMediaList = function exportByMediaList(csvFileName, isAllContacts, selectedMediaListId, pageSize, q) {
                var payload = {
                    fileName: csvFileName,
                    mediaListIds: isAllContacts ? [] : [selectedMediaListId],
                    isAllContacts: isAllContacts,
                    pageSize: pageSize
                };

                if(q !== '') {
                    payload.q = q;
                }

                return $q(function(resolve, reject) {
                    $http.post(CONTACT_MANAGER_EXPORT_URL + '/contacts/csv/medialist', payload).then(function(response) {
                        InfluencerContactService.downloadCsv(response.data);

                        resolve({success: true});
                    }).catch(function(response) {
                        reject(response.data);
                    });
                }).catch(function() {});
            };

            InfluencerContactService.exportByStat = function exportByStat(csvFileName, distributionId, pageSize, statType, clickedLink) {
                var payload = {
                    fileName: csvFileName,
                    sourceId: distributionId,
                    pageSize: pageSize,
                    clickedLink: clickedLink
                };

                return $q(function(resolve, reject) {
                    $http.post(CONTACT_MANAGER_EXPORT_URL + '/contacts/csv/' + statType, payload).then(function(response) {
                        InfluencerContactService.downloadCsv(response.data);

                        resolve({success: true});
                    }).catch(function(response) {
                        reject(response.data);
                    });
                });
            };

            InfluencerContactService.exportByUnsubscribes = function exportByUnsubscribes(csvFileName, distributionId, pageSize, reason) {
                var payload = {
                    fileName: csvFileName,
                    sourceId: distributionId,
                    pageSize: pageSize,
                    reason: reason,
                    appIds: 'ICM'
                };

                return $q(function(resolve, reject) {
                    $http.post(CONTACT_MANAGER_EXPORT_URL + '/contacts/csv/unsubscribed', payload).then(function(response) {
                        InfluencerContactService.downloadCsv(response.data);

                        resolve({success: true});
                    }).catch(function(response) {
                        reject(response.data);
                    });
                });
            };

            InfluencerContactService.downloadCsv = function downloadCsv(fileName) {
                var link,
                    ev;
                link = document.createElement('a');
                link.href = CONTACT_MANAGER_EXPORT_URL + '/contacts/' + encodeURIComponent(fileName);
                link.style.visibility = 'hidden';
                document.body.appendChild(link);
                ev = document.createEvent('MouseEvents');
                ev.initMouseEvent(
                    'click',
                    false,   /* bubble */
                    false, /* cancelable */
                    window, 0, 0, 0, 1, 1, false, false, false, false, 0, null /*Rest initMouseEventArguments*/
                );
                link.dispatchEvent(ev);
                document.body.removeChild(link);
            };

            InfluencerContactService.deletePrivateContacts = function deletePrivateContacts(contactIds){
                var payload = {contactIds: contactIds};

                return $http.post(CONTACT_MANAGER_CONTACT_URL + '/delete', payload);
            };

            InfluencerContactService.deleteContact = function deleteContact(contactId) {
                var defer = $q.defer();

                $http.delete(CONTACT_MANAGER_CONTACT_URL + '/' + contactId).then(function () {
                    defer.resolve({message: 'Success. Your contact has been deleted.'});
                }).catch(function (response) {
                    defer.reject(response.data);
                });

                return defer.promise;
            };

            InfluencerContactService.getContactById = function getContactById(contactId) {
                var defer = $q.defer();

                ICMUserService.getIdentity().then((identity) => {
                    $http.get(ICM_CONTACTS_URL + '/contacts/' + identity.company._id + '/' + contactId).then(function(response) {
                        //extract sourceIds from the sourceSnippets to load source objects
                        var sourceIds = [],
                            contact = response.data,
                            sources = contact.sourceSnippets;

                        (sources || []).forEach(function(source) {
                            if (source.id) {
                                sourceIds.push(source.id);
                            }
                        });

                        if (sourceIds.length > 0) {
                            ContactManagerSourceService.getSourcesByIds(sourceIds).then(function(sources) {
                                defer.resolve(new Contact(contact, sources));
                            });
                        } else {
                            defer.resolve(new Contact(contact, []));
                        }
                    }).catch(function(response) {
                        defer.reject(response.data);
                    });
                }).catch(function(err) {
                    defer.reject(err);
                });

                return defer.promise;
            };

            InfluencerContactService.getContactsById = function getContactById(contactIds) {
                var defer = $q.defer();

                var req = {
                    method: 'POST',
                    url: `${ICM_CONTACTS_URL}/contacts`,
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    data: { contactIds: contactIds }
                };

                $http(req).then(function(response) {
                    var contacts = response.data.hits;

                    for (let i = 0; i < contacts.length; i++) {
                        contacts[i] = new Contact(contacts[i], []);
                    }

                    defer.resolve(contacts);
                }).catch(function(response) {
                    defer.reject(response.data);
                });
                return defer.promise;
            };

            InfluencerContactService.searchContacts = function searchContacts(query) {
                var defer = $q.defer();

                $http.post(CONTACT_MANAGER_CONTACT_URL + '/search', query).then(function(response) {
                    if (response.data.hits) {
                        response.data.hits = response.data.hits.map(function (hit) {
                            return new Contact(hit.quiddity, response.data.sources);
                        }.bind(this));
                    }
                    defer.resolve(response.data);
                }.bind(this)).catch(function(response) {
                    defer.reject(response.data);
                });

                return defer.promise;
            };

            InfluencerContactService.aggregateContactSearch = function aggregateContactSearch(query) {
                var defer = $q.defer();

                $http.post(ICM_CSS_URL + '/search/contacts', query).then(function(response) {
                    if (response.data.hits) {
                        response.data.hits = response.data.hits.map(function (hit) {
                            return new Contact(hit);
                        });
                    }
                    defer.resolve(response.data);
                }).catch(function(response) {
                    defer.reject(response.data);
                });

                return defer.promise;
            };

            InfluencerContactService.aggregateSourceSearch = function aggregateSourceSearch(query) {
                var defer = $q.defer();

                $http.post(ICM_CSS_URL + '/search/sources', query).then(function(response) {
                    defer.resolve(response.data);
                }.bind(this)).catch(function(response) {
                    defer.reject(response.data);
                });

                return defer.promise;
            };

            InfluencerContactService.aggregateRelevantContacts = function aggregateRelevantContacts(query) {
                var defer = $q.defer();

                $http.post(ICM_CSS_URL + '/v2/search/relevantContacts', query).then(function(response) {
                    if (response.data.hits) {
                        response.data.hits = response.data.hits.map(function (hit) {
                            return new Contact(hit);
                        }.bind(this));
                    }
                    defer.resolve(response.data);
                }.bind(this)).catch(function(response) {
                    defer.reject(response.data);
                });

                return defer.promise;
            };

            InfluencerContactService.aggregateRelevantSources = function aggregateRelevantSources(query) {
                var defer = $q.defer();

                $http.post(ICM_CSS_URL + '/v2/search/relevantSources', query).then(function(response) {
                    defer.resolve(response.data);
                }.bind(this)).catch(function(response) {
                    defer.reject(response.data);
                });

                return defer.promise;
            };

            InfluencerContactService.getBySourceSuggest = function getBySourceSuggest(query, size) {
                var suggestUrl = ICM_CSS_URL + '/search/suggest',
                    payload = {
                        q: query,
                        size: size || 3
                    },
                    defer = $q.defer();

                $http.post(suggestUrl, payload).then(function (response) {
                    defer.resolve(response.data);
                }.bind(this)).catch(function (response) {
                    defer.reject(response.data);
                }.bind(this));

                return defer.promise;
            };

            InfluencerContactService.setCurrentContact = function setCurrentContact(contact){
                InfluencerContactService.currentContact = new Contact(contact);
            };

            InfluencerContactService.getCurrentContact = function getCurrentContact(contactId){
                var defer = $q.defer();

                //make sure we don't display the wrong contact
                if(InfluencerContactService.currentContact && InfluencerContactService.currentContact.id === contactId){
                    defer.resolve(InfluencerContactService.currentContact);
                }else{
                    InfluencerContactService.getContactById(contactId).then(function(newContact){
                        defer.resolve(newContact);
                    });
                }

                return defer.promise;
            };

            InfluencerContactService.getMasterList =  function getMasterList(query) {
                var defer = $q.defer();

                query.isMasterList = true;

                $http.post(CONTACT_MANAGER_CONTACT_URL + '/search/mediaList', query).then(function(response) {
                    if (response.data.hits) {
                        response.data.hits = response.data.hits.map(function (hit) {
                            return new Contact(hit.quiddity, response.data.sources);
                        }.bind(this));
                    }
                    defer.resolve(response.data);
                }.bind(this)).catch(function(response) {
                    defer.reject(response.data);
                });

                return defer.promise;
            };

            InfluencerContactService.getByMediaListIds =  function getByMediaListIds(query) {
                var defer = $q.defer();

                $http.post(CONTACT_MANAGER_CONTACT_URL + '/search/mediaList', query).then(function(response) {
                    if (response.data.hits) {
                        response.data.hits = response.data.hits.map(function (hit) {
                            return new Contact(hit.quiddity, response.data.sources);
                        }.bind(this));
                    }
                    defer.resolve(response.data);
                }.bind(this)).catch(function(response) {
                    defer.reject(response.data);
                });

                return defer.promise;
            };

            // can remove this function when we get rid of the XXX split
            InfluencerContactService.addNote = function addNote(contactId, note) {
                var deferred = $q.defer(),
                    payload = {
                        contactId: contactId,
                        note: note
                    };

                $http.post(CONTACT_MANAGER_NOTES_URL, payload)
                    .then(function() {
                        deferred.resolve({message: 'Success. Your contact has been updated.'});
                    })
                    .catch(function() {
                        deferred.reject({message: 'Add faild'});
                    });

                return deferred.promise;
            };

            // can remove this function when we get rid of the XXX split
            InfluencerContactService.editNote = function editNote(contactId, noteId, note) {
                var deferred = $q.defer(),
                    payload = {
                        note: note
                    };

                $http.put(CONTACT_MANAGER_NOTES_URL + '/' + noteId, payload)
                    .then(function() {
                        deferred.resolve({message: 'Success. Your contact has been updated.'});
                    })
                    .catch(function(response) {
                        deferred.reject(response.data);
                    });

                return deferred.promise;
            };

            InfluencerContactService.addActivity = function addActivity(contactId, type, subject, body, date, author) {
                var deferred = $q.defer(),
                    payload = {
                        contactId: contactId,
                        type: type,
                        subject: subject,
                        body: body,
                        date: date,
                        author: author
                    };
                $http.post(INFLUENCERS_URL + '/activities', payload)
                    .then(function() {
                        deferred.resolve({message: 'Success. Your contact has been updated.'});
                    })
                    .catch(function() {
                        deferred.reject({message: 'Add failed'});
                    });

                return deferred.promise;
            };

            InfluencerContactService.editActivity = function editActivity(activityId, contactId, type, subject, body, date, author) {
                var deferred = $q.defer(),
                    payload = {
                        contactId: contactId,
                        type: type,
                        subject: subject,
                        body: body,
                        date: date,
                        author: author
                    };

                $http.put(INFLUENCERS_URL + '/activities/' + activityId, payload)
                    .then(function() {
                        deferred.resolve({message: 'Success. Your contact has been updated.'});
                    })
                    .catch(function(response) {
                        deferred.reject(response.data);
                    });

                return deferred.promise;
            };

            InfluencerContactService.deleteNotes = function deleteNotes(contactId, noteIds) {
                var deferred = $q.defer(),
                    payload = {
                        noteIds: noteIds
                    };

                $http.post(CONTACT_MANAGER_NOTES_URL + '/bulkDelete', payload)
                    .then(function() {
                        deferred.resolve({message: 'Success. Your contact has been updated.'});
                    })
                    .catch(function(response) {
                        deferred.reject(response.data);
                    });

                return deferred.promise;
            };


            InfluencerContactService.getNotes = function getNotes(contactId) {
                var deferred = $q.defer();

                $http.get(CONTACT_MANAGER_NOTES_URL + '?contactId=' + contactId)
                    .then(function(response) {
                        deferred.resolve(response.data);
                    })
                    .catch(function(response) {
                        deferred.reject(response.data);
                    });

                return deferred.promise;
            };

            InfluencerContactService.relevantContactsCount = function relevantContactsCount(query) {
                var httpRequest,
                    deferred = $q.defer(),
                    _query = angular.copy(query);

                _query.pageSize = 500;
                _query.page = 0;
                _query.groupOption = 'none';

                httpRequest = $http.post(CONTACT_MANAGER_CONTACT_URL + '/search/documents/count', _query);

                httpRequest.then(function(response) {
                    var count = response.data > 499 ? '+500' : response.data;
                    deferred.resolve(count);
                }.bind(this)).catch(function(response) {
                    deferred.reject(response.data);
                });

                return deferred.promise;
            };

            InfluencerContactService.relevantContacts = function relevantContacts(query){
                var httpRequest,
                    deferred = $q.defer();

                httpRequest = $http.post(CONTACT_MANAGER_CONTACT_URL + '/search/documents', query);

                httpRequest.then(function(response) {
                    var formattedResponse = {
                            count: 0,
                            hits: [],
                            articleCountMapping: {}
                        };

                    if (response.data.contacts) {
                        formattedResponse.count = response.data.contacts.length;

                        response.data.contacts.forEach(function(contact) {
                            var contactViewModel = new Contact(contact.contact, contact.sources);

                            formattedResponse.hits.push(contactViewModel);
                            formattedResponse.articleCountMapping[contactViewModel.id] = contact.authoredArticlesCount || 0;
                        }, this);
                    }
                    deferred.resolve(formattedResponse);
                }.bind(this)).catch(function(response) {
                    deferred.reject(response.data);
                });

                return deferred.promise;
            };

            InfluencerContactService.relevantArticles = function relevantArticles(query, additionalQueryParams) {
                let deferred = $q.defer(),
                payload = {
                    query: query,
                    contactId: additionalQueryParams.contactId,
                    numDups: 20
                };

                $http.post(ICM_DOCUMENT_SERVICE_URL + '/documents/relevant/contact' , payload)
                    .then(function onSuccess(response) {
                        let formatDocs = this.InfluencerContactService.formatRelevantArticlesBySourceResponse(response.data, query);
                        deferred.resolve(formatDocs);
                    }.bind(this))
                    .catch(function onError(response){
                        deferred.reject(response.data);
                    });

                return deferred.promise;
            };

            InfluencerContactService.relevantArticlesBySource = function relevantArticlesBySource(query, additionalQueryParams) {
                let deferred = $q.defer(),
                    payload = {
                        query: query,
                        sourceIds: [additionalQueryParams.sourceId],
                        numDups: 20
                    };

                if(query.childIds){
                    payload.sourceIds = payload.sourceIds.concat(query.childIds);
                    delete query.childIds;
                }

                $http.post(ICM_DOCUMENT_SERVICE_URL + '/documents/relevant/source' , payload)
                    .then(function onSuccess(response) {
                        let formatDocs = this.InfluencerContactService.formatRelevantArticlesBySourceResponse(response.data, query);
                        deferred.resolve(formatDocs);
                    }.bind(this))
                    .catch(function onError(response){
                        deferred.reject(response.data);
                    });

                return deferred.promise;
            };

            InfluencerContactService.formatRelevantArticlesBySourceResponse = function formatRelevantArticlesBySourceResponse (response, initialQuery){
                let formattedResponse = {
                   documents: [],
                   totalDocuments: 0,
                   totalPages: 0,
                   totalGroups: 0
                };
                try{
                    if(response && response.views) {
                        if(response.views.count && response.views.count.totalCount) {
                            formattedResponse.totalDocuments = response.views.count.totalCount;
                            formattedResponse.totalPages = Math.ceil(formattedResponse.totalDocuments / initialQuery.pageSize);
                        }
                        if(response.views.list && response.views.list.groupCount) {
                            formattedResponse.totalGroups = response.views.list.groupCount;
                        }

                        if(response.views.list && response.views.list.results) {
                            // handle duplicate documents, putting them into the expected format
                            response.views.list.results.forEach(function(documentGroup) {
                                var parentDocument = documentGroup.documents[0].gyda;
                                parentDocument.dupDocsCount = (documentGroup.count > 1) ? documentGroup.count -1 : 0 ;
                                parentDocument.dupDocs = [];
                                parentDocument.remainingDocIds = documentGroup.remainingDupDocsIds;
                                for (var i = 1; i < documentGroup.documents.length; i++) {
                                    parentDocument.dupDocs.push(documentGroup.documents[i].gyda);
                                }
                                formattedResponse.documents.push(parentDocument);
                            });
                        }
                    }
                    return formattedResponse;
                } catch(error){
                    throw error;
                }
            };

            InfluencerContactService.pruneChannelSources = function pruneChannelSources(contact, sources){
                sources.forEach(function(source){
                    if(source.parentIds && source.sourceType !== 'bureau'){
                        source.parentIds.forEach(function(id){
                            contact.channels.forEach(function(channel, index, arr){
                                if(channel.sourceId && channel.sourceId === id){
                                    arr.splice(index,1);
                                }
                            });
                        });
                    } else if(source.sourceType === 'bureau'){
                        contact.channels.forEach(function(channel, index, arr){
                            if(channel.sourceId && channel.sourceId === source.id){
                                arr.splice(index,1);
                            }
                        });
                    }
                });
            };

            InfluencerContactService.getContactsByStat = function getContactsByStat(query) {
                let analyticsApiPayload = JSON.parse(JSON.stringify(query));
                delete analyticsApiPayload.pathParams;
                const distributionId = query.pathParams.distributionId;
                const statType = query.pathParams.statType;
                const analyticsUrl = ICM_EMAIL_API_URL + '/analytics/distributions/' + distributionId + '/' + statType + '/recipients';

                function formatContactResponse(contactEmailsArray, contacts, totalCount) {
                    let bFound = false;
                    let contactObject = {};

                    if (contactEmailsArray && contacts.length < contactEmailsArray.length) {
                        // display email addresses for missing contacts (from CSS)
                        contactEmailsArray.forEach((emailAddress) => {
                            bFound = false;
                            contactObject = {
                                id: 'other_contact_' + emailAddress,
                                name: {
                                    firstName: emailAddress,
                                    middleName: '',
                                    lastName: ''
                                },
                                contactInfo:{
                                    email:[{
                                        address: emailAddress,
                                        type: 'work'
                                    }]
                                }
                            };

                            bFound = contacts.find((contact) => {
                                return (contact.contactInfo.email[0].address === emailAddress);
                            });

                            if (typeof bFound === 'undefined') {
                                contacts.push(new Contact(contactObject, []));
                            }
                        });
                    }

                    return {
                        count: totalCount,
                        hits: contacts
                    };
                }

                return $http.post(analyticsUrl, analyticsApiPayload)
                    .then((response) => {
                        const contacts = response.data.contacts;
                        const count = response.data.count;

                        let contactIdsArray = contacts.map(a => a.contactIds[0]);
                        let contactEmailsArray = contacts.map(a => a.emailAddress);
                        let cssQuery = {
                            page: 0,
                            pageSize: 25,
                            anyKeywords: contactIdsArray
                        };

                        if(contactIdsArray.length === 0) {
                            return formatContactResponse(contactEmailsArray, []);
                        } else {
                            return this.InfluencerContactService.getByContactIds(cssQuery).then((response) => {
                                return formatContactResponse(contactEmailsArray, response.hits, count);
                            });
                        }
                    })
                    .catch(() => {
                        return [];
                    });
            };

            InfluencerContactService.getContactIdsByStat = function getContactsByStat(query) {
                let analyticsApiPayload = JSON.parse(JSON.stringify(query));
                delete analyticsApiPayload.pathParams;
                const distributionId = query.pathParams.distributionId;
                const statType = query.pathParams.statType;
                const analyticsUrl = ICM_EMAIL_API_URL + '/analytics/distributions/' + distributionId + '/' + statType + '/recipients';

                return $http.post(analyticsUrl, analyticsApiPayload)
                    .then((response) => {
                        return response.data.contacts;
                    })
                    .catch(() => {
                        return [];
                    });
            };

            InfluencerContactService.getByContactIds = function getByContactIds(query) {
                var defer = $q.defer();

                if (query.anyKeywords) {
                    query.anyKeywords = query.anyKeywords.filter(Boolean);
                }

                $http.post(CONTACT_MANAGER_CONTACT_URL + '/search/Ids', query).then(function(response) {
                    if (response.data.hits) {
                        response.data.hits = response.data.hits.map(function (hit) {
                            return new Contact(hit.quiddity, response.data.sources);
                        }.bind(this));
                    }

                    defer.resolve(response.data);
                }.bind(this)).catch(function(response) {
                    defer.reject(response.data);
                });

                return defer.promise;
            };

            InfluencerContactService.getUnsubscribed = function getUnsubscribed(query) {
                return $q(function(resolve, reject) {
                    $http.post(CONTACT_MANAGER_CONTACT_URL + '/unsubscribed/' + query.distributionId, query)
                        .then(function(response) {
                            if (response.data.hits) {
                                response.data.hits = response.data.hits.map(function (hit) {
                                    return new Contact(hit.quiddity, response.data.sources);
                                }.bind(this));
                            }

                            resolve(response.data);
                        }.bind(this))
                        .catch(function(response) {
                            reject(response.data);
                        });
                });
            };

            InfluencerContactService.getUnsubscribedByEmail = function getUnsubscribedByEmail(payload) {
                return $q(function(resolve, reject) {
                    $http.post(CONTACT_MANAGER_CONTACT_URL + '/unsubscribed/search', payload)
                        .then(function(response) {
                            resolve(response.data);
                        })
                        .catch(function(response) {
                            reject(response.data);
                        });
                });
            };

            InfluencerContactService.getOpenRate = function getOpenRate(query) {
                var payload = {
                    stat: query.type,
                    distributionId: query.distributionId,
                    page: query.page,
                    pageSize: query.pageSize,
                    clickedLink: query.clickedLink
                };

                return $q(function(resolve, reject) {
                    $http.post(CONTACT_MANAGER_CONTACT_URL + '/email/stats', payload)
                        .then(function(response) {
                            if (response.data.hits) {
                                response.data.hits = response.data.hits.map(function (hit) {
                                    return new Contact(hit.quiddity, response.data.sources);
                                }.bind(this));
                            }

                            resolve(response.data);
                        }.bind(this))
                        .catch(function(response) {
                            reject(response.data);
                        });
                });
            };

            InfluencerContactService.autocomplete = function autocomplete(query) {
                var defer = $q.defer();

                $http.post(CONTACT_MANAGER_CONTACT_URL + '/search/autocomplete', query).then(function(response) {
                    if (response.data.hits) {
                        response.data.hits = response.data.hits.map(function (hit) {
                            return new Contact(hit.quiddity, response.data.sources);
                        }.bind(this));
                    }
                    defer.resolve(response.data);
                }.bind(this)).catch(function(response) {
                    defer.reject(response.data);
                });

                return defer.promise;
            };

            InfluencerContactService.INFLUENCER_APP = 'influencerApp';

            InfluencerContactService.getRecentDocuments = function getRecentDocuments(searchQueryType, ids) {
                if (searchQueryType.toLowerCase() === 'contact') {
                    return this.getRecentDocumentsForContact(ids[0]);
                } else if (searchQueryType.toLowerCase() === 'source') {
                    return this.getRecentDocumentsForSource(ids);
                }
            };

            InfluencerContactService.getRecentDocumentsForSource = function getRecentDocumentsForSource(sourceIds) {
                var httpOptions = {
                    method: 'POST',
                    url: ICM_DOCUMENT_SERVICE_URL + '/documents/recent/source',
                    data: {
                        sourceIds: sourceIds
                    }
                };

                return $q(function(resolve, reject) {
                    $http(httpOptions)
                        .then(function(response) {
                            var transformedResponse = {
                                    totalDocuments: 0,
                                    documents: []
                                },
                                responseViews;

                            if(response && response.data && response.data.views) {
                                responseViews = response.data.views;

                                if(responseViews.documentCount && responseViews.documentCount.totalCount) {
                                    transformedResponse.totalDocuments = responseViews.documentCount.totalCount;
                                }

                                if(responseViews.searchResults && responseViews.searchResults.results && Array.isArray(responseViews.searchResults.results)) {
                                    responseViews.searchResults.results.forEach(function(result) {
                                        if(result.gyda) {
                                            transformedResponse.documents.push(result.gyda);
                                        }
                                    });
                                }
                            }


                            resolve(transformedResponse);
                        })
                        .catch(function(err) {
                            reject(err);
                        });
                });
            };

            InfluencerContactService.getRecentDocumentsForContact = function getRecentDocumentsForContact(contactId) {
                var defaultDates = DateRangeHelper.getDateRange(14),
                    jsonObj = {
                        'dateStart':defaultDates.dateStart,
                        'dateEnd':defaultDates.dateEnd,
                        'pageSize':10,
                        'page':0,
                        'sortOrder':'DESC',
                        'sortField':'date',
                        'groupOption':'none',
                        'searchRequestId':0,
                        'caseSensitive':'no',
                        'sourceSelectionId':1,
                        'informationTypes':[],
                        'allKeywords':[''],
                        'anyKeywords':[],
                        'notKeywords':[],
                        'keyphraseHistogram':100,
                        'searchQueryType': 'contact',
                        'authorId': contactId
                    };

                    return $q(function(resolve, reject) {
                        CoreUserService.getCurrent(true).then((currentUser) => {
                            ICMUserService.getAppSettings('search', currentUser._id).then((appSettings) => {
                                if(appSettings && appSettings.groupOption) {
                                    jsonObj.groupOption = appSettings.groupOption;
                                }
                            })
                            .then(function() {
                                $http.post(DOCUMENT_SEARCH_SERVICE_URL + '/recentDocuments', jsonObj, {headers:{'x-client-name':'icm-web-assets'}}).then(function(response) {
                                    resolve(response.data);
                                })
                                .catch(function(err) {
                                    reject(err);
                                });
                            })
                            .catch(function(error) {
                                reject(error);
                            });
                        });
                    }).catch(function() {});
            };

            InfluencerContactService.getByContactAndSourceSuggest = function getByContactAndSourceSuggest(query, size) {
                var suggestUrl = ICM_CSS_URL + '/search/suggest',
                    payload = {
                        q: query,
                        size: size || 3
                    },
                    defer = $q.defer();

                $http.post(suggestUrl, payload).then(function (response) {
                    defer.resolve(response.data);
                }.bind(this)).catch(function (response) {
                    defer.reject(response.data);
                }.bind(this));
                return defer.promise;
            };

            InfluencerContactService.getRecentSearches = function getRecentSearches(page, pageSize) {
                var url = ICM_CSS_URL + '/search/getRecentSearches',
                    defer = $q.defer(),
                    payload = {
                        page: page || 0,
                        pageSize: pageSize || 5
                    };

                $http.post(url, payload).then(function (response) {
                    defer.resolve(response.data);
                }.bind(this)).catch(function (response) {
                    defer.reject(response.data);
                }.bind(this));
                return defer.promise;
            };

            InfluencerContactService.saveRecentSearch = function saveRecentSearch(payload) {
                var url = ICM_CSS_URL + '/search/recentSearches',
                    defer = $q.defer();

                $http.post(url, payload).then(function (response) {
                    defer.resolve(response.data);
                }.bind(this)).catch(function (response) {
                    defer.reject(response.data);
                }.bind(this));
                return defer.promise;
            };

            InfluencerContactService.submitContactCreateFeedback = function submitContactCreateFeedback(payload) {
                var url = ICM_CONTACT_SERVICE_URL + '/contacts/feedback/missing',
                    defer = $q.defer();

                $http.post(url, payload).then(function (response) {
                    defer.resolve(response.data);
                }).catch(function (error) {
                    defer.reject(error);
                });
                return defer.promise;
            };

            InfluencerContactService.submitSourceCreateFeedback = function submitSourceCreateFeedback(payload) {
                let url = ICM_SOURCE_SERVICE_URL + '/sources/feedback/missing',
                    config = {
                        headers: {
                                'x-client-name': 'media-relations'
                            }
                    },
                    defer = $q.defer();

                $http.post(url, payload, config).then(function (response) {
                    defer.resolve(response.data);
                }).catch(function (error) {
                    defer.reject(error);
                });
                return defer.promise;
            };

            return InfluencerContactService;
        }
    ] );
